// extracted by mini-css-extract-plugin
export default {"credits":"credits_credits__fLsj2"};